import React, { Fragment, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ENUM_ORDER_STATUS } from 'utils/enum';
import { getOrderStatus } from 'utils/functions';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import OngoingOrder from './ongoing-order';
import CompletedOrder from './completed-order';
import { Bars } from 'react-loader-spinner';
import CancelledOrder from './cancelled-order';
import RecurringOrder from './recurring-order';
import { OrderType } from 'models/order.model';

const OrderDetails = () => {
  const [searchParams] = useSearchParams();
  const { setBackLinkTitle, setIsBackLink, setBackLink, setIsBasketDisabled } =
    useDashboardContext();
  const [order, setOrder] = useState<OrderType | null>(null);
  const [loading, setLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState('');
  const { id } = useParams();

  const getOrderDetails = async () => {
    if (!id) return;
    try {
      setLoading(true);
      const details = await apiService.get(`orders/code/${id}`, {
        baseURL: process.env.REACT_APP_CORE_API_URL
      });
      setOrder(details?.data?.order);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getOrderDetails();
  }, [id]);
  useEffect(() => {
    setIsBackLink(true);
    setIsBasketDisabled(true);
    setBackLinkTitle('Return to previous');

    if (searchParams.get('edit') === 'true') {
      setBackLink(`/orders/${order?.order_code}`);
      setBackLinkTitle('Return to order');
    } else {
      setBackLink('/orders');
    }
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, [order, searchParams]);

  useEffect(() => {
    if (order) {
      setOrderStatus(getOrderStatus(order));
    }
  }, [order]);

  return (
    <Fragment>
      {loading ? (
        <div className='grow w-full h-screen flex justify-center pt-[25vh]'>
          <Bars color='#E60A2B' height={50} width={50} />
        </div>
      ) : (
        order && (
          <div className='w-full'>
            {orderStatus === ENUM_ORDER_STATUS.ONGOING ||
            orderStatus === ENUM_ORDER_STATUS.SCHEDULED ||
            orderStatus === ENUM_ORDER_STATUS.PENDING ? (
              <OngoingOrder order={order} />
            ) : orderStatus === ENUM_ORDER_STATUS.COMPLETED ? (
              <CompletedOrder order={order} />
            ) : orderStatus === ENUM_ORDER_STATUS.CANCELLED ||
              orderStatus === ENUM_ORDER_STATUS.REJECTED ? (
              <CancelledOrder order={order} />
            ) : orderStatus === ENUM_ORDER_STATUS.RECURRING ? (
              <RecurringOrder order={order} />
            ) : null}
          </div>
        )
      )}
    </Fragment>
  );
};

export default OrderDetails;
